<template>
  <div class="container mb-m">
    <h2 :class="titleClass">
      {{ title }}
      <span v-text="tips" />
    </h2>
    <div
      v-if="reset"
      class="mb-s"
    >
      <template v-if="reset">
        <Button
          type="warning"
          shape="circle"
          icon="refresh"
          @click="handleReset"
        />
        <span :style="utilTipsStyle">清除所有選取方案</span>
      </template>
      <slot name="collapse" />
    </div>
    <div :class="`collapse ${isCollapse ? 'active' : ''}`">
      <Row class="product-row" :gutter="30">
        <Col
          v-for="prod in prods"
          :key="prod.insuId"
          :xs="24"
          :sm="12"
          :md="8"
        >
          <InsuProdCard
            v-model="val"
            v-bind="{prod}"
            :loading="$attrs.loading"
            :triggerModal="$attrs.triggerModal"
          />
        </Col>
      </Row>
      <Carousel
        navigationEnabled
        :paginationEnabled="false"
        :perPageCustom="[
          [300, 1],
          [600, 1],
          [992, 2],
          [1200, 3]
        ]"
      >
        <Slide
          v-for="prod in prods"
          :key="prod.insuId"
        >
          <InsuProdCard
            v-model="val"
            v-bind="{prod}"
            :loading="$attrs.loading"
            :triggerModal="$attrs.triggerModal"
          />
        </Slide>
      </Carousel>
    </div>
  </div>
</template>

<script>
  import { Button, Row, Col } from 'iview';
  import { Carousel, Slide } from 'vue-carousel';
  import InsuProdCard from './InsuProdCard';

  export default {
    inheritAttrs: false,
    components: {
      Button,
      Row,
      Col,
      InsuProdCard,
      Carousel,
      Slide
    },
    props: {
      title: {
        type: String,
        default: null
      },
      tips: {
        type: String,
        default: null
      },
      prods: {
        type: Array,
        default: () => []
      },
      reset: {
        type: Boolean,
        default: false
      },
      isCollapse: {
        type: Boolean,
        default: false
      },
      value: {
        type: Object,
        default: null
      },
      triggerScrollToProd: {
        type: Function,
        default: () => {}
      }
    },
    data() {
      return {
        utilTipsStyle: {
          margin: '0 15px 0 10px',
          fontSize: '14px'
        }
      };
    },
    computed: {
      titleClass() {
        return {
          'section-title': true,
          'mb-xs': this.reset,
          'mb-s': !this.reset
        };
      },
      val: {
        get() { return this.value; },
        set(val) { return this.$emit('input', val); }
      }
    },
    watch: {
      prods(val) {
        if (!val) return;
        this.triggerScrollToProd();
      }
    },
    mounted() {
      this.triggerScrollToProd();
    },
    methods: {
      handleReset() {
        this.$emit('input', null);
      }
    }
  };
</script>